import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';

document.querySelectorAll('.swiper').forEach((swiperEl) => {
    const controls = swiperEl.previousElementSibling;

    const next = controls.querySelector('.btn-next');
    const prev = controls.querySelector('.btn-prev');

    new Swiper(swiperEl, {
        modules: [Navigation],

        allowTouchMove: false,
        autoHeight: true,
        loop: true,
        spaceBetween: '24px',

        navigation: {
            nextEl: next,
            prevEl: prev,
        },
    });
});